import { useState } from "react";
import { useSelector, useDispatch } from 'react-redux';
import styled from "styled-components";
import { signupUser } from "Features/api/api";
import Spinner from "SharedFns/SpinnerElement";
import { keyframes } from "styled-components";



const RegForm = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const error = useSelector(state => state.auth.error);
  const isLoading = useSelector(state => state.auth?.loading);
  const validationErrors = useSelector((state) => state.auth.validationErrors);

  const [formData, setFormData] = useState({
    first_name: '', last_name: '', phone: '', email: '', RegNo: '',
    username: '', password: '', confirm_password: ''
  });

  const handleOnchange = e => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(signupUser(formData));
  };

  if (!isOpen) return null;

  return (
    <Overlay>
      <ModalContainer>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Container>
          <Title>Create your account</Title>
          <p>Please provide the most accurate and present details regarding you.</p>

          {isLoading && <Spinner />}

          {validationErrors && Object.keys(validationErrors).length > 0 && (
            <div>
              <h2>Validation Errors:</h2>
              {Object.entries(validationErrors).map(([field, messages]) => (
                <div key={field}>
                  <strong>{field}:</strong>
                  <ul>
                    {messages.map((message, index) => (
                      <li key={index}>{message}</li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          )}

          <SignUpForm>
            <form onSubmit={handleSubmit}>
              <FormOuterRow>
                <Form_Row>
                  <label htmlFor="first_name">Firstname</label>
                  <input name="first_name" id="first_name" type="text" placeholder="Firstname" onChange={handleOnchange} required />
                </Form_Row>
                <Form_Row>
                  <label htmlFor="last_name">Lastname</label>
                  <input name="last_name" id="last_name" type="text" placeholder="Lastname" onChange={handleOnchange} required />
                </Form_Row>
              </FormOuterRow>

              <FormOuterRow>
                <Form_Row>
                  <label htmlFor="username">Username</label>
                  <input name="username" id="username" type="text" placeholder="Username" onChange={handleOnchange} required />
                </Form_Row>
                <Form_Row>
                  <label htmlFor="email">Email</label>
                  <input name="email" id="email" type="email" placeholder="Email" onChange={handleOnchange} required />
                </Form_Row>
              </FormOuterRow>

              <FormOuterRow>
                <Form_Row>
                  <label htmlFor="RegNo">Registration Number</label>
                  <input name="RegNo" id="RegNo" type="text" placeholder="Eye20 Reg.No" onChange={handleOnchange} required />
                </Form_Row>
                <Form_Row>
                  <label htmlFor="phone">Phone Number</label>
                  <input name="phone" id="phone" type="number" placeholder="Phone Number" onChange={handleOnchange} required />
                </Form_Row>
              </FormOuterRow>

              <FormOuterRow>
                <Form_Row>
                  <label htmlFor="password">Create Password</label>
                  <input name="password" id="password" type="password" placeholder="Password" onChange={handleOnchange} required />
                </Form_Row>
                <Form_Row>
                  <label htmlFor="confirm_password">Confirm Password</label>
                  <input name="confirm_password" id="confirm_password" type="password" placeholder="Confirm Password" onChange={handleOnchange} required />
                </Form_Row>
              </FormOuterRow>

              <AuthButtons>
                <SignUpBtn type="submit">Register</SignUpBtn>
              </AuthButtons>
            </form>
          </SignUpForm>
        </Container>
      </ModalContainer>
    </Overlay>
  );
};

export default RegForm;

// ================== Styled Components ==================
const fadeIn = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;


const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100vw; height: 100vh;
  background: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
 
`;

const ModalContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  padding: 30px;
  border-radius: 12px;
  max-width: 750px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  z-index: 2000;
  animation: ${fadeIn} 0.3s ease-in-out;

`;


const CloseButton = styled.button`
  position: absolute;
  right: 20px;
  top: 15px;
  font-size: 24px;
  background: transparent;
  border: none;
  color: #555;
  cursor: pointer;
  z-index: 2100; /* Ensure it's on top of everything */
  &:hover {
    color: #e2725b;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  
`;
const Title = styled.h3`
  font-size: 1.5rem;
  color: #003366;
`;
const SignUpForm = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`;

const FormOuterRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const Form_Row = styled.div`
  margin-bottom: 10px;
  margin-right: 5px;
  display: flex;
  flex-direction: column;
  width: 100%;

  input {
    border: none;
    border-bottom: 1px solid #353935;
    outline: none;
    width: 100%;
  }

  label {
    font-size: 12px;
    margin-bottom: 4px;
  }
`;

const AuthButtons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  margin-top: 20px;
`;

const SignUpBtn = styled.button`
  margin-left: 0px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
  padding: 10px 30px;
  border-radius: 10px;
  background-color: #e2725b;
  color: #f9f9f9;
  border: none;
  @media (max-width: 768px) {
    font-size: 10px;
    padding: 5px 15px;
  }
`;
